import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { PoolNotification, SnackbarSlice, notificationsSelector, remove } from '@synergy/shared/snackbar/data-access';
import { WithSnackbarProps, withSnackbar } from 'notistack';
import { connect } from 'react-redux';

interface NotifierProps extends WithSnackbarProps {
    notifications: PoolNotification[];
    remove: (key: number) => void;
}

class NotifierBase extends Component<NotifierProps> {
    private displayed: number[] = [];
    private maxStoreItems = 20;

    private storeDisplayed = (key: number) => {
        this.displayed = [...this.displayed.slice(-this.maxStoreItems), key];
    };

    public override shouldComponentUpdate({ notifications: newSnacks }: NotifierProps) {
        const { notifications: currentSnacks } = this.props;
        let notExists = false;
        for (const snack of newSnacks) {
            if (notExists) {
                continue;
            }
            notExists = notExists || !currentSnacks.filter(({ key }) => snack.key === key).length;
        }
        return notExists;
    }

    public override componentDidUpdate() {
        const { notifications = [] } = this.props;

        notifications.forEach(notification => {
            // Do nothing if snackbar is already displayed
            if (this.displayed.includes(notification.key)) {
                return;
            }
            // Display snackbar using notistack
            this.props.enqueueSnackbar(<FormattedMessage id={notification.message} values={notification.values} />, {
                variant: notification.variant ?? 'info',
            });
            // Keep track of snackbars that we've displayed
            this.storeDisplayed(notification.key);
            // Dispatch action to remove snackbar from redux store
            this.props.remove(notification.key);
        });
    }

    public override render() {
        return null;
    }
}

const NotifierWithSnackbar = withSnackbar(NotifierBase);

const mapStateToProps = (store: SnackbarSlice) => ({
    notifications: notificationsSelector(store),
});

export const Notifier = connect(mapStateToProps, {
    remove,
})(NotifierWithSnackbar);
